import React from 'react'
import {Redirect, Route} from 'react-router'
import { KEYS } from '../constants/keysStorage'

interface IParent {
  component: React.ComponentType<any>
  [ket: string]: any
}

const PrivateRoute = ({component: Component, ...rest}: IParent) => {
  let auth = localStorage.getItem(KEYS.ID_CLIENT)
  return <Route {...rest}>{auth ? <Component /> : <Redirect to='/' />}</Route>
}

export default PrivateRoute
